/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-decoration-2': {
    width: 33,
    height: 53,
    viewBox: '0 0 33 53',
    data: '<path pid="0" class="st0" d="M22.7 19.7s-4.5 1-6.7 1-6.6-.9-6.7-1c-.5-.1-1 .2-1.2.8-.1.5.2 1.1.8 1.2.2 0 4.7 1 7.1 1 2.4 0 6.9-1 7.1-1 .5-.1.9-.6.8-1.2-.1-.6-.7-1-1.2-.8"/><path pid="1" class="st0" d="M24.1 28.5h.5c2.4 0 4.5-.9 5.9-2.6 1.4-1.7 1.9-3.9 1.4-6.2C31.8 18.5 29.7 0 16 0 2.5 0 .3 18.3.2 19.6c-.5 2.3 0 4.4 1.3 6.1 1.4 1.7 3.6 2.7 6 2.7H8L1 50.7c-.2.5.1 1.1.6 1.2h.3c.4 0 .8-.3.9-.7l7.1-22.9h12L29 51.2c.1.4.5.7.9.7h.3c.5-.2.8-.7.6-1.2l-6.7-22.2zM3 24.5c-1-1.2-1.3-2.8-.9-4.5v-.1C2.1 19.7 3.8 2 16 2c12.2 0 13.9 17.7 14 17.9v.1c.3 1.8 0 3.4-1 4.6-1 1.2-2.6 1.9-4.4 1.9H7.5c-1.8 0-3.5-.7-4.5-2"/>'
  }
})
